import BasicLayout from "@/layouts/basic-layout";
const meta = {
  auth: true
};
const pre = "staff-identity-";
export default {
  path: "/staff-identity",
  name: "staff-identity",
  redirect: {
    name: `${pre}staff-list`
  },
  meta,
  component: BasicLayout,
  children: [{
    path: "staff-list",
    name: `${pre}staff-list`,
    meta: {
      ...meta,
      title: "员工识别信息"
    },
    component: () => import("@/pages/staff-identity/staff-list")
  }, {
    path: "tag-config",
    name: `${pre}tag-config`,
    meta: {
      ...meta,
      title: "员工标签设置"
    },
    component: () => import("@/pages/staff-identity/tag-config")
  }, {
    path: "tag-task",
    name: `${pre}tag-task`,
    meta: {
      ...meta,
      title: "标签同步任务"
    },
    component: () => import("@/pages/staff-identity/tag-task")
  }, {
    path: "import",
    name: `${pre}import`,
    meta: {
      ...meta,
      title: "批量上传"
    },
    component: () => import("@/pages/staff-identity/import")
  }, {
    path: "import-record",
    name: `${pre}import-record`,
    meta: {
      ...meta,
      title: "导入记录"
    },
    component: () => import("@/pages/staff-identity/import-record")
  }]
};